/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A reading frame is where you start grouping bases into triplets. A sequence has three possible forward frames (starting at position 1, 2 or 3), and the correct one begins at the start codon.`)
};

const es_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un marco de lectura es el punto donde comienzas a agrupar bases en tripletes. Una secuencia tiene tres marcos directos posibles (comenzando en la posición 1, 2 o 3), y el correcto comienza en el codón de inicio.`)
};

const de_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Leseraster ist die Stelle, an der Sie beginnen, Basen zu Tripletts zu gruppieren. Eine Sequenz hat drei mögliche Vorwärts-Leseraster (beginnend bei Position 1, 2 oder 3), und das richtige beginnt beim Startcodon.`)
};

const nl_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een leesframe is waar je begint met het groeperen van basen in tripletten. Een sequentie heeft drie mogelijke voorwaartse frames (beginnend op positie 1, 2 of 3), en het juiste begint bij het startcodon.`)
};

const fr_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un cadre de lecture est l'endroit où vous commencez à grouper les bases en triplets. Une séquence a trois cadres avant possibles (commençant à la position 1, 2 ou 3), et le bon commence au codon d'initiation.`)
};

const it_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una fase di lettura è dove inizi a raggruppare le basi in triplette. Una sequenza ha tre possibili fasi in avanti (a partire dalla posizione 1, 2 o 3), e quella corretta inizia al codone di inizio.`)
};

const pt_br2_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um quadro de leitura é onde você começa a agrupar bases em trincas. Uma sequência tem três quadros diretos possíveis (começando na posição 1, 2 ou 3), e o correto começa no códon de início.`)
};

const pt_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma grelha de leitura é o ponto a partir do qual se começam a agrupar as bases em trincas. Uma sequência tem três grelhas diretas possíveis (começando na posição 1, 2 ou 3), e a correta começa no codão de início.`)
};

const ja_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`塩基を三つ組にグループ化し始める位置のことです。配列には3つの可能な正方向の読み枠（位置1、2、3から開始）があり、正しい読み枠は開始コドンから始まります。`)
};

const zh_translate_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读框是指从哪里开始将碱基分组为三联体。一个序列有三种可能的正向阅读框（从位置 1、2 或 3 开始），正确的阅读框应从起始密码子开始。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_faq_a1", locale)
	if (locale === "en") return en_translate_faq_a1(inputs)
	if (locale === "es") return es_translate_faq_a1(inputs)
	if (locale === "de") return de_translate_faq_a1(inputs)
	if (locale === "nl") return nl_translate_faq_a1(inputs)
	if (locale === "fr") return fr_translate_faq_a1(inputs)
	if (locale === "it") return it_translate_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_translate_faq_a1(inputs)
	if (locale === "pt") return pt_translate_faq_a1(inputs)
	if (locale === "ja") return ja_translate_faq_a1(inputs)
	return zh_translate_faq_a1(inputs)
};